import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import './BreadCrumbs.scss';

export default MuiBreadcrumbs;
